import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MuiPicker } from '../../../../MuiPicker'
import { isValid, format } from 'date-fns'
import './teacher-calendar-lesson-details.css'
const TeacherCalendarLessonDetails = ({setStep, event, setEvent, createCalendarEvent, setLoading, loading, saveError}) => {
    const [somethingWasChanged, setSomethingWasChanged] = React.useState(false)

    const changeLessonLength = (value) => {
        setSomethingWasChanged(true)
        setEvent((prev) => ({...prev, lessonLength: value}))
    }

    const changeRepeatStatus = (value) => {
        setSomethingWasChanged(true)
        value === 'none' ? setEvent((prev) => ({...prev, recurring:{isOn: false, frequency: value, interval: 0}})) : setEvent((prev) => ({...prev, recurring:{isOn: true, frequency: value, interval: 0}}))
      }
    
    const createEventAndResetCount = () => {
      if(!loading) {
        if(isValidISODate(event.dateTime)) {
          createCalendarEvent(event)
          setLoading(true)
        }
      }
    }

    const isValidISODate = (isoDateString) => {
      const date = new Date(isoDateString);
      return !isNaN(date.getTime());
    }

    return (
        <div className='teacher-calendar-lesson-details__wrapper'>
            <div className='teacher-calendar-lesson-details'>
              <div className='teacher-calendar-lesson-details__title'>Lesson Details</div>
                <div className='inline-block mt-10 mb-5'>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MuiPicker setNewEvent={setEvent} newEvent={event} setSomethingWasChanged={setSomethingWasChanged} />
                  </LocalizationProvider>
                  {!isValidISODate(event.dateTime) && <div className='teacher-calendar-lesson-details__date-time-warning'>Date/Time must be valid</div>}
                </div>
                <div className='text-left'>
                  <div className='text-xs font-bold text-gray-500'>Lesson Length:</div>
                  <select className='w-full p-2 rounded-md border-gray-200 mb-5 ' onChange={(e) => changeLessonLength(e.target.value)} value={event.lessonLength}>
                    <option value={15}>15 minutes</option>
                    <option value={30}>30 minutes</option>
                    <option value={45}>45 minutes</option>
                    <option value={60}>60 minutes</option>
                  </select>
                </div>
                {event.dateTime !== null && isValidISODate(event.dateTime) && 
                            <div>
                              <div className='text-xs font-bold text-gray-500'>Repeats:</div>
                              <select value={event.recurring.frequency} className='text-sm p-2 border-gray-200 rounded-md w-full mb-5' onChange={(e) => changeRepeatStatus(e.target.value)}>
                                <option value="none">Does not Repeat</option>
                                <option value="weekly">Weekly on {event.dateTime && format(new Date(event.dateTime), 'EEEE')}</option>
                                <option value="every-other-week">Every Other {event.dateTime && format(new Date(event.dateTime), 'EEEE')}</option>
                              </select>
                            </div>
                          }
                {saveError && (
                  <div className='teacher-calendar-lesson-details__date-time-warning'>
                    {saveError}
                  </div>
                )}
                <div className='teacher-calendar-lesson-details__btn-wrapper'>
                    <div className='teacher-calendar-lesson-details__btn' onClick={() => setStep(1)}>Back</div>
                    <div className='teacher-calendar-lesson-details__btn teacher-calendar-lesson__save-lesson__btn' style={isValidISODate(event.dateTime) ? {cursor: 'pointer', backgroundColor: '#7939EE', border: '1px solid #7939EE'} : {cursor: 'default', backgroundColor: 'gray', border: '1px solid gray'}} onClick={() => createEventAndResetCount()}>Create Event</div>
                </div>
            </div>
        </div>
    )
}
export default TeacherCalendarLessonDetails
